export default "__VITE_ASSET__DzhDeK0J__"